import React, { useState } from "react";
import { Button, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import "../../common/CustomModal.css";

const CommentHistoryModal = ({ show, handleClose, comments }) => {
  return (
    <Modal
      className="custom-modal1 p-10"
      size="md"
      centered
      show={show}
      onHide={handleClose}
    >
      <div class="header-pop p-3 mb-1">
        <div class="header-title">Coment History</div>
        <a class="close-pop" onClick={() => handleClose()}>
          ×
        </a>
      </div>
      <Modal.Body style={{ width: "100%" }}>
        <div className="history-container">
          <table className="table table-bordered table-sm fs-10">
            <thead>
              <tr>
                <th style={{ width: '30%' }}>Date & Time</th>
                <th>Comment</th>
              </tr>
            </thead>
            <tbody>
              {comments && comments.map((comment) => {
                const dateTime = new Date(comment.createdAt).toLocaleString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true, // use false for 24-hour format
                });
                const [date, time] = dateTime.split(","); // Split into date and time
                return (
                  <tr key={comment._id?.$oid || comment._id}>
                    <td style={{ textAlign: 'center' }}>
                      <div>{date}</div>
                      <div>{time}</div>
                    </td>
                    <td>{comment.desc}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </Modal.Body>

    </Modal>
  );
};

export default CommentHistoryModal;
